import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';

import { BirEditModalComponent } from '../../modal/bir-edit-modal/bir-edit-modal.component';
import { SelectInstantBaseComponent } from '../selectInstant-base';

@Component({
  selector: 'app-rv-bir-select',
  templateUrl: './rv-bir-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RvBirSelectComponent),
      multi: true
    }
  ]
})
export class RvBirSelectComponent extends SelectInstantBaseComponent {
  @ViewChild(BirEditModalComponent) birEditModal!: BirEditModalComponent;

  constructor(http: _HttpClient, cdr: ChangeDetectorRef, router: Router) {
    super(http, cdr, router);
  }

  getUrl(searchValue: string): string {
    let filter = `IsCompany ne true and IsAR eq true`;
    if (searchValue) {
      const searchFields = [
        'code',
        'companyName',
        'firstName',
        'middleName',
        'lastName',
        'tinNumber',
        'tinBranchCode',
        'address'
      ];
      const searchStr = searchValue.replaceAll("'", "''");
      const searchFilter = searchFields
        .map(x => `contains(${x}, '${encodeURIComponent(searchStr)}')`)
        .join(' or ');
      filter = `${filter} and (${searchFilter})`;
    }
    return `api/BIRClassifications/Query?$top=50&$skip=0&$orderby=code asc&$filter=${filter}`;
  }

  override addNew() {
    this.birEditModal.showNew({
      isAR: true
    });
  }

  selectBir(data: any) {
    if (data) {
      if (data.id) {
        this.valueChanged(data);
      } else {
        this.http.post('api/BIRClassifications/create', data).subscribe(res => {
          if (res) {
            this.list = [res];
            this.valueChanged(res);
          }
        });
      }
    } else {
      this.valueChanged(data);
    }
  }

  jump(): string {
    return '';
  }

  queryParam(): String {
    return '';
  }
}
